import $, { speed } from "jquery";
import _ from 'lodash';
import Splide from "@splidejs/splide";
import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';
import SimpleParallax from 'simple-parallax-js';



Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);


const mq = (device) => {
  if (window.matchMedia('(max-width:768px)').matches && device === 'sp') {
    return true;
  }
  return window.matchMedia('(min-width:769px)').matches && device === 'pc';
};


const topSlider = () => {
  const firstViewSlider = document.querySelector(".top-slider");
  if (!firstViewSlider) return;
  new Splide('.splide').mount();

  const splide = new Splide('.splide', {
    type: 'fade',
    autoplay: true,
    rewind: true,
    interval: 3500, // 自動再生の間隔
    speed: 3200, // フェードする時間
  });

  splide.mount();
};




// .js-target というクラス名を持つ要素を監視し、画面内に入ったら is-active クラスを追加するシンプルな実装
const scrollAnimation = () => {
  // 監視対象の要素をすべて取得
  const targets = document.querySelectorAll(".js-target");
  if (!targets) return; // 監視対象がなければ処理を終了

  // IntersectionObserverのコールバック関数
  const cb = (entries, observer) => {
    entries.forEach((entry) => {
      // 要素がビューポートに入った場合
      if (entry.isIntersecting) {
        // 要素にクラスを追加
        entry.target.classList.add("is-active");
        // 監視を解除
        observer.unobserve(entry.target);
      }
    });
  };

  // IntersectionObserverのオプション設定
  const options = {
    root: null, // ビューポートを基準にする
    rootMargin: "0px", // ビューポートのマージンを設定
    threshold: 0.3, // 要素が少しでも表示されたら発火
  };

  // IntersectionObserverのインスタンスを作成
  const io = new IntersectionObserver(cb, options);

  // 監視対象の各要素を監視
  targets.forEach((target) => {
    io.observe(target);
  });

};








const menuToggleFunc = () => {
  const mTrigger = document.getElementById("menu-trigger");  // mTriggerを定義
  const jsMenuChildren = document.querySelectorAll(".js-menu");  // jsMenuChildrenを定義
  // ハンバーガーアイコンに対しての処理
  if (mTrigger) {
    mTrigger.addEventListener("click", () => {
      document.body.classList.toggle("menu-show");
    });
  }
  // navを押下した時の処理
  if (jsMenuChildren.length > 0) {
    jsMenuChildren.forEach((child) => {
      // navをClickした時.menu-showの有無を見て付け外しをする
      child.addEventListener("click", () => {
        if (document.body.classList.contains("menu-show")) {
          document.body.classList.remove("menu-show");
        }
      });
    });
  }
};


const formCheck = () => {
  const targets = document.getElementById("formPage1");
  if (!targets) return; // 監視対象がなければ処理を終了

  // エラーを表示する関数（error クラスの p 要素を追加して表示）
  function showError(message, this$) {
    let text = this$.parent().find("label").text() + message;
    this$.parent().append(`<p class='error'>${text}</p>`);
  }

  // フォームが送信される際のイベントハンドラの設定
  // eslint-disable-next-line consistent-return
  $("#formPage1").submit(() => {
    // エラー表示の初期化
    $("p.error").remove();
    $("div").removeClass("error");
    let text = "";
    $("#errorDispaly").remove();

    // メールアドレスの検証
    let email = $.trim($("#email").val());
    if (
      email &&
      // eslint-disable-next-line no-useless-escape
      !/^([a-z0-9\+_\-]+)(\.[a-z0-9\+_\-]+)*@([a-z0-9\-]+\.)+[a-z]{2,6}$/gi.test(email)
    ) {
      $("#email").after("<p class='error'>メールアドレスの形式が異なります</p>");
    }
    // 電話番号の検証
    let tel = $.trim($("#tel").val());
    if (
      tel &&
      // eslint-disable-next-line no-useless-escape
      !/^\(?\d{2,5}\)?[-(\.\s]{0,2}\d{1,4}[-)\.\s]{0,2}\d{3,4}$/gi.test(tel)
    ) {
      $("#tel").after("<p class='error'>電話番号の形式が異なります（半角英数字でご入力ください）</p>");
    }
    // カナの検証
    let kana = $.trim($("#kana").val());
    if (kana && !kana.match(/^[ァ-ヶー]+$/)) {
      $("#kana").after("<p class='error'>全角カタカナではない文字が含まれています</p>");
    }
    // 1行テキスト入力フォームとテキストエリアの検証
    $(":text,textarea")
      .filter(".validate")
      // eslint-disable-next-line func-names
      .each(function () {
        // 必須項目の検証
        $(this)
          .filter(".required")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val() === "") {
              showError("必須項目です", $(this));
            }
          });
        // 文字数の検証
        $(this)
          .filter(".max30")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val().length > 30) {
              showError(" は30文字以内です", $(this));
            }
          });
        $(this)
          .filter(".max50")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val().length > 50) {
              showError(" は50文字以内です", $(this));
            }
          });
        $(this)
          .filter(".max100")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val().length > 100) {
              showError(" は100文字以内です", $(this));
            }
          });
        $(this)
          .filter(".max1000")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val().length > 1000) {
              showError(" は1000文字以内でお願いします", $(this));
            }
          });
      });

    // error クラスの追加の処理
    if ($("p.error").length > 0) {
      $("p.error").parent().addClass("error");
      $("html,body").animate({ scrollTop: $("p.error:first").offset().top - 180 }, "slow");
      return false;
    }
  });
};



window.addEventListener('DOMContentLoaded', (event) => {
  menuToggleFunc();
  topSlider();
  scrollAnimation();
  formCheck();
});
